var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CCard',[_c('CCardHeader',[_c('span',{staticStyle:{"font-size":"18px","line-height":"24px","font-weight":"600","color":"#3b4859"}},[_vm._v("Upload Catalog")])]),_c('Upload',{attrs:{"map":_vm.map},on:{"uploadcb":_vm.handlecb}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }